// Small formatting helpers shared across web screens.

export function formatCurrency(value) {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(num);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("it-IT", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return "—";
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("it-IT", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(iso));
  } catch {
    return "—";
  }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1) return "ora";
  if (mins < 60) return `${mins} min fa`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} h fa`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days} g fa`;
  return formatDate(iso);
}

export const ACCOUNT_LABELS = {
  azienda: "Azienda / Committente",
  vettore: "Autotrasportatore / Vettore",
  autista: "Autista",
};

export const STATUS_LABELS = {
  published: "Pubblicato",
  open: "Aperto",
  assigned: "Assegnato",
  in_transit: "In transito",
  in_corso: "In corso",
  delivered: "Consegnato",
  completed: "Completato",
  cancelled: "Annullato",
  draft: "Bozza",
  pending: "In attesa",
  accepted: "Accettato",
  rejected: "Rifiutato",
};

export function statusLabel(status) {
  if (!status) return "—";
  return STATUS_LABELS[status] || status;
}
